<template>
  <div class="recruit-carousel">
    <div class="recruit-carousel__data">
      <div class="recruit-carousel__data__box">
        <h3 data-eng="RECRUIT">採用情報</h3>
        <dl>
          <dt>レイワスチールでは、一般事務・鉄筋加工スタッフとして働く仲間を募集しています。</dt>
          <dd class="btn"><a href="/recruit/">採用情報を見る</a></dd>
        </dl>
      </div>
    </div>
    <swiper
      :modules="modules"
      :slides-per-view="'auto'"
      :looped-slides="list.length"
      :space-between="0"
      :speed="5000"
      :loop="true"
      :autoplay="{ delay: 0, disableOnInteraction: false, pauseOnMouseEnter: false }"
      :allowTouchMove="false" 
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="(item, index) in list" :key="index">
        <img :src="item.pic" alt="photo">
      </swiper-slide>
    </swiper>
  </div>
</template>

<style lang="scss" scoped>
.recruit-carousel{
  position: relative;
  &__data{
    position: absolute;
    top: 0;
    left: 50%;
    width: 500px;
    height: 100%;
    transform: translateX(-50%);
    background: module.$gray;
    @include module.flex();
    align-items: center;
    justify-content: center;
    z-index: 100;
    @media screen and (max-width: module.$phone){
      position: relative;
      width: auto;
      transform: translate(0, 0);
      left: 0;
    }
    &__box{
      padding: 32px 56px;
      text-align: center;
      @media screen and (max-width: module.$phone){
        padding: 24px;
      }
      h3{
        font-size: 1.32rem;
        line-height: 1;
        @media screen and (max-width: module.$phone){
          font-size: 1.08rem;
        }
        &:before{
          content: attr(data-eng);
          font-size: 3.2rem;
          letter-spacing: .08em;
          font-weight: 700;
          display: block;
          margin: 0 0 8px;
          @media screen and (max-width: module.$phone){
            font-size: 2rem;
          }
        }
      }
      dl{
        margin: 24px 0 0;
        dt{
          font-size: 1.24rem;
          line-height: 1.66;
          @media screen and (max-width: module.$phone){
            font-size: 1.08rem;
          }
        }
        dd{
          &.btn{
            text-align: center;
            margin: 1.6rem 0 0;
            a{
              font-size: 1.12rem;
              display: inline-block;
              background: module.$normal;
              color: module.$lime;
              padding: .8rem 1.6rem;
              border-radius: .64rem;
              transition: 300ms;
              &:hover{
                color: module.$normal;
                background: module.$lime;
                box-shadow: 0 0 2.4rem rgba(module.$lime, 0.8);;
              }
            }
          }
        }
      }
    }
  }
}
.swiper-slide{
  width: auto;
}
img{
  width: auto;
  height: 24rem;
  object-fit: cover;
  @media screen and (max-width: module.$phone){
    height: 10rem;
  }
}
</style>

<script>
import { ref, toRefs } from 'vue'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

export default {
  props: {
    list: {
      type: Array,
      required: true
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup(props) {
    const breakpoints = {
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 0,
      },
      769: {
        slidesPerView: 'auto',
        spaceBetween: 0,
      },
    };

    const onSwiper = (swiper) => {
      setTimeout(()=>{
        swiper.slideNext()
      },100)
    }
    const onSlideChange = () => {
    }
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay],
      breakpoints,
    }
  },
}
</script>
